import api from "../utils/axios";

export const getSupportTickets = async (params = {}) => {
  try {
    const {
      page = 1,
      limit = 20,
      status,
      priority,
      category,
      search = "",
      assignedTo,
      isBot,
      sortBy = "createdAt",
      sortOrder = "desc",
    } = params;

    const response = await api.get(`/admin/support-tickets`, {
      params: {
        page,
        limit,
        status,
        priority,
        category,
        search,
        assignedTo,
        isBot,
        sortBy,
        sortOrder,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateSupportTicket = async (ticketId, ticketData) => {
  try {
    const response = await api.put(
      `/admin/support-tickets/${ticketId}`,
      ticketData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteSupportTicket = async (ticketId) => {
  try {
    const response = await api.delete(`/admin/support-tickets/${ticketId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getSupportTicketById = async (ticketId) => {
  try {
    const response = await api.get(`/admin/support-tickets/${ticketId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const addNoteToTicket = async (ticketId, noteData) => {
  try {
    const response = await api.post(
      `/admin/support-tickets/${ticketId}/notes`,
      noteData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
